<template>
  <div class="page-bg  " :style="'min-height:'+pageBgHeight+'px' " ref="pageBg">
    <div class="web-body" :style="'min-height:'+pageBgHeight+'px' ">
      <div class="left-nav">
        <div class="left-nav-left">
          <div>
            <router-link to="/about" class="left-nav-left-item">
              <div class="left-nav-left-item-active"></div>
              <div class="left-nav-left-item-title">公司简介</div>
            </router-link>
            <router-link to="/milestone" class="left-nav-left-item">
              <div class="left-nav-left-item-active"></div>
              <div class="left-nav-left-item-title">发展历程</div>
            </router-link>
            <router-link to="/cooperation" class="left-nav-left-item">
              <div class="left-nav-left-item-active"></div>
              <div class="left-nav-left-item-title">联系我们</div>
            </router-link>
          </div>
        </div>
        <div class="left-nav-right">
          <div class="left-nav-right-title-box">
            <div class="left-nav-right-title">{{titleMap[activeName]}}</div>
          </div>
          <div class="left-nav-right-content">
            <div v-show="activeName==='about'" class="left-nav-right-content-about">
              <div style="text-indent:0.68rem">
                广州勇往科技有限公司成立于2016年，是一家以“成为优秀的游戏研发商”为企业愿景，以“打造高品质游戏”为企业使命的研发、发行互联网游戏公司，先后获得金沙江等知名创投机构的四轮投资。
              </div>
              <div style="text-indent:0.68rem;margin-top: 15px">
                公司由拥有十余年游戏从业经验的精英团队领衔。旗下拥有多个研发品牌橙艺和奇异果等，专业的轻中度游戏发行品牌勇往游戏，亿级用户千万日活的流量平台品牌小贝传媒，形成研发-发行-流量商业闭环模式，专注于轻中度游戏研发与发行，立足于各游戏平台、国内外安卓&iOS市场，已经连续打造众多爆款国内海外产品，走向日韩欧美等多个国家和地区，拥有超过5亿游戏用户。
              </div>
              <div style="text-indent:0.68rem;margin-top: 15px">
                产品范围涵盖了益智解谜、格斗、放置经营、slg等类型，近年来成功上线《小兵冲冲冲》、《疯狂奔跑》、《画画猜猜》、《最强的大脑》、《猜歌达人》、《疯狂搬砖》、《解救美人鱼》、《疯狂挖矿》等上百款游戏。
              </div>
              <div style="text-indent:0.68rem;margin-top: 15px">
                面对千变万化的市场需求和层出不穷的挑战，勇往科技将秉承“玩家至上”的理念，不断为玩家打造精彩纷呈的精品游戏。
              </div>
              <div style="margin-top: 15px">
                企业价值观：
                <ul style="margin-bottom: 0">
                  <li>
                    坦诚清晰
                  </li>
                  <li>
                    开放谦虚
                  </li>
                  <li>
                    积极进取
                  </li>
                  <li>
                    务实创新
                  </li>
                </ul>
              </div>
              <div style="text-indent:0.68rem;margin-top: 15px">
                2020年我们在路上，公司发展进入了快车道，需要注入新的能量与我们共同成长。这里没有繁文缛节的流程，也没有复杂的江湖恩怨，如果你对这个大大的世界依然充满了好奇，如果你和我们一样不想辜负了这个时代，那么请带着你充满创造力的性感大脑，和充满好奇心的大心脏，赶紧上船吧！
              </div>
              <div style="height: 300px"></div>
            </div>
            <div v-show="activeName==='milestone'" class="left-nav-right-content-milestone">
              <div class="develop-box">
                <div class="develop-time">
                  <span>2016</span>
                  <span>11月</span>
                </div>
                <div class="develop-icon"><img src="../assets/images/1.png" class="img-responsive"
                                               alt="Responsive image">
                </div>
                <div class="develop-text">
                  <p>勇往科技<span class="blue">成立</span></p>
                  <p>获数百万融资</p>
                  <p>荣获广州市首届「海创会」创业大赛二等奖</p>
                </div>
              </div>
              <div class="develop-box">
                <div class="develop-time">
                  <span>2017</span>
                  <span>8月</span>
                </div>
                <div class="develop-icon"><img src="../assets/images/2.png" class="img-responsive"
                                               alt="Responsive image">
                </div>
                <div class="develop-text">
                  <p>【画画猜猜】日活人数突破<span class="blue"> 100万人</span></p>
                </div>
              </div>
              <div class="develop-box">
                <div class="develop-time">
                  <span>2017</span>
                  <span>12月</span>
                </div>
                <div class="develop-icon"><img src="../assets/images/2.png" class="img-responsive"
                                               alt="Responsive image">
                </div>
                <div class="develop-text">
                  <p>【猜歌达人】日活人数突破<span class="blue"> 300万人</span></p>
                </div>
              </div>
              <div class="develop-box">
                <div class="develop-time">
                  <span>2018</span>
                  <span>9月</span>
                </div>
                <div class="develop-icon"><img src="../assets/images/7.png" class="img-responsive"
                                               alt="Responsive image">
                </div>
                <div class="develop-text">
                  <p>勇往科技游戏用户量超过<span class="blue">1亿</span></p>
                </div>
              </div>
              <div class="develop-box">
                <div class="develop-time">
                  <span>2019</span>
                  <span>12月</span>
                </div>
                <div class="develop-icon"><img src="../assets/images/7.png" class="img-responsive"
                                               alt="Responsive image">
                </div>
                <div class="develop-text">
                  <p>勇往科技游戏用户量超过<span class="blue">5亿</span></p>
                </div>
              </div>
              <div style="font-size: .33rem;padding-top:30px;text-indent:0.66rem">
                历程太多随便写几条有个仪式感而已，我们是个务实低调的团队，曾经的成就已过去，期待未来更多的同行和小伙伴加入携手合作共创佳绩。
              </div>
              <div style="height: 300px"></div>
            </div>
            <div v-show="activeName==='cooperation'" class="left-nav-right-content-cooperation">
              <div class="left-nav-right-content-cooperation-info">
                <div class="left-nav-right-content-cooperation-info-item">
                  <div class="left-nav-right-content-cooperation-info-item-title">商务洽谈</div>
                  <div class="left-nav-right-content-cooperation-info-item-desc">BD@yongwangkeji.cn</div>
                </div>
                <div class="left-nav-right-content-cooperation-info-item">
                  <div class="left-nav-right-content-cooperation-info-item-title">招聘邮箱</div>
                  <div class="left-nav-right-content-cooperation-info-item-desc">hr@yongwangkeji.cn</div>
                </div>
                <div class="left-nav-right-content-cooperation-info-item">
                  <div class="left-nav-right-content-cooperation-info-item-title">联系地址</div>
                  <div class="left-nav-right-content-cooperation-info-item-desc">广州市天河区珠江东路30号广州银行大厦6楼601A-601B</div>
                </div>
              </div>
              <b-map-component></b-map-component>
              <div style="height: 300px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BMapComponent from './BMapComponent';

  export default {
    name: "leftNav",
    props: {
      activeName: {
        required: true,
        type: String,
        default: 'about'
      }
    },
    components: {
      'b-map-component': BMapComponent
    },
    data() {
      return {
        pageBgHeight: 1000,
        navHeight: 900,
        slide: 0,
        sliding: null,
        titleMap: {
          about: "公司简介",
          milestone: "发展历程",
          cooperation: "联系我们",
        },
        developItems: [
          {
            year: '2016',
            month: '9月',
            icon: require('../assets/images/1.png'),
            content:
              '              <p>勇往科技<span class="blue">在广州成立</span></p>\n' +
              '              <p>获数百万融资</p>\n' +
              '              <p>荣获广州市首届「海创会」创业大赛二等奖</p>\n'
          },
          {
            year: '2017',
            month: '5月',
            icon: require('../assets/images/2.png'),
            content:
              '              <p><span class="blue">【画画猜猜】和【猜歌达人】</span></p>\n' +
              '              <p>小程序正式上线</p>\n'
          },
          {
            year: '2017',
            month: '7月',
            icon: require('../assets/images/3.png'),
            content: '<p>获得飞马资本,数百万元<span class="blue"> Pre-A </span>轮融资</p>'
          },
        ]
      }
    },
    watch: {
      activeName: {
        handler: function (info) {
          this.getPageBgHeight();
        },
        immediate: true
      },
    },
    mounted() {
      window.scrollTo(0, 0)
      const that = this;
      this.getPageBgHeight();
      window.addEventListener("resize", function () {
        return (() => {
          that.getPageBgHeight();
        })();
      });
    },
    created() {

    },
    methods: {
      getPageBgHeight() {
        if (!this.timer) {
          this.timer = true
          setTimeout(() => {
            let pos = this.$refs.pageBg.getBoundingClientRect();
            this.pageBgHeight = Math.ceil(window.innerHeight - Math.abs(pos.top));
            this.navHeight = this.pageBgHeight;
            this.timer = false
          }, 500)
        }

      }
    }
  }
</script>

<style scoped>
  .web-body {
    padding-top: 2rem;
    background: #F9F9F9;
    height: 100%;
  }

  .left-nav {
    width: inherit;
    border-top: 0.04rem solid rgba(250, 124, 0, .25);
    display: flex;
    background: #F9F9F9;
    height: 100%;
  }


  .left-nav-left {
    width: 6.66rem;
    font-size: 0.4rem;
    color: rgba(250, 124, 0, 1);
    padding-right: 0.32rem;
    border-right: 0.04rem solid rgba(250, 124, 0, .25);
  }

  .left-nav-left-item {
    height: 2rem;
    border-bottom: 0.04rem solid rgba(250, 124, 0, .25);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .left-nav-left-item:last-child {
    border-bottom: 0;
  }

  .left-nav-left-item-active {
    background: none;
    border-radius: 50%;
    margin-right: 10px;
    width: 0.16rem;
    height: 0.16rem;
  }

  .left-nav-left-item-title {
    color: rgba(250, 124, 0, 1);;
  }

  .left-nav-left-item.router-link-active:hover .left-nav-left-item-active {
    background-color: rgba(250, 124, 0, 0.6);
  }

  .left-nav-left-item:hover .left-nav-left-item-title {
    color: rgba(250, 124, 0, 0.6);
  }

  .router-link-active .left-nav-left-item-active {
    background-color: rgba(250, 124, 0, 1);
  }

  .left-nav-right {
    width: 100%;
    padding: 0 0.32rem;
    box-sizing: border-box;
  }

  .left-nav-right-title-box {
    font-size: 0.4rem;
    color: rgba(250, 124, 0, 1);
    height: 2rem;
    border-bottom: 0.04rem solid rgba(250, 124, 0, .25);
    width: 100%;
    padding-top: 1rem;
    text-align: center;
  }

  .left-nav-right-title {

  }

  .left-nav-right-content {
    font-size: 0.34rem;
    color: #0E99C4;
  }

  .left-nav-right-content-about {
    padding: 0.8rem;
    box-sizing: border-box;
  }

  .left-nav-right-content-milestone {
    padding: 0.8rem;
    box-sizing: border-box;
  }

  .left-nav-right-content-cooperation {
    padding: 0.8rem;
    box-sizing: border-box;
    font-size: 0.34rem;
    color: #0E99C4;
  }

  .left-nav-right-content-cooperation-info {
    margin-bottom: 1rem;
  }

  .left-nav-right-content-cooperation-info-item {
    margin-bottom: 0.5rem;
  }

  .left-nav-right-content-cooperation-info-item-desc {
    color: rgba(14, 153, 196, .8);
    font-size: 0.28rem;
  }


  .develop-box {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    margin-bottom: 0.88rem;
  }

  .develop-box:last-child {
    margin-bottom: 0;
  }

  .develop-box .develop-time {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    margin-right: 2rem;
  }

  .develop-box .develop-time span:nth-child(1) {
    font-size: 0.5rem;
    font-weight: bold;
    color: #444444;
    line-height: 0.8rem;
    text-align: center;
  }

  .develop-box .develop-time span:nth-child(2) {
    font-size: 0.33rem;
    color: #FFFFFF;
    background: #1199D9;
    border-radius: 0.1rem;
    width: 1.68rem;
    height: 0.62rem;
    text-align: center;
    line-height: 0.62rem;
  }

  .develop-box .develop-icon {
    width: 1.66rem;
    height: 1.66rem;
    margin-right: 1.38rem;
    position: relative;
  }

  .develop-box .develop-icon > img {
    width: 1.66rem;
    height: 1.66rem;
  }

  .develop-box .develop-icon:before {
    content: '';
    width: 2px;
    height: 1rem;
    background: #D8D8D8;
    position: absolute;
    left: 0.8rem;
    top: 1.6rem;
  }

  .develop-box:last-child .develop-icon:before {
    content: '';
    background: none;
  }

  .develop-box .develop-text {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    justify-content: center;

    font-size: 0.33rem;
    color: #333333;
    line-height: 0.43rem;
    width: 6rem;
  }

  .develop-box .develop-text p {
    margin: 0;
  }

  .develop-box .develop-text .blue {
    color: #1199D9;
  }

  @media screen and (max-width: 450px) {
    .develop-box .develop-time {
      margin-right: 1rem;
    }

    .develop-box .develop-icon {
      margin-right: 1rem;
    }

    .develop-box .develop-text {
      width: 4rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/leftNav.vue